// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// vuex
import store from './store'
// import "@/assets/lib/bootstrap4.5.0/bootstrap.min.css"
import request from '@/components/common/js/request';

import '@/assets/css/base.css'
// import Popper from 'vue-popperjs';
  // import 'vue-popperjs/dist/vue-popper.css';
// 路由守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // console.log(to);
  // console.log(from);
  if (to.meta.isLogin) { // 判断该路由是否需要登录权限
    if(JSON.parse(localStorage.getItem('islogin'))){ //判断本地是否存在access_token
      next();
    }else {
      next({
        path:'/login/'
      })
    }
  }
  else {
    next();
  }
  /*如果本地 存在 token 则 不允许直接跳转到 登录页面*/
  if(to.fullPath == "/login/"){
    if(JSON.parse(localStorage.getItem('islogin'))){
      next({
        path:'/storereport'
      });
    }else {
      next();
    }
  }
  if(to.fullPath == "/login/register"){
    if(JSON.parse(localStorage.getItem('islogin'))){
      next({
        path:'/storereport'
      });
    }else {
      next();
    }
  }
})

import Promise from 'es6-promise'
Promise.polyfill()


import "@/assets/font/iconfont.js"

// import Blob from ""
import router from './router.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import zh_tran from '@/assets/langs/lang';

//挂载时间转换器
import formatDate from './time'
Vue.prototype.$time=formatDate
//挂载时间转换器
import setTime from './setTime'
Vue.prototype.$settime=setTime
//挂载oss上传
import configOss from './configOss'
Vue.prototype.$UploadOss=configOss
Vue.use(ElementUI);

Vue.prototype.request = request;
Vue.prototype.$zh_tran = zh_tran;

// import { Message } from 'element-ui';
// Vue.use(Message);
// Vue.prototype.$message = Message;
  

// import layer from 'vue-layer'
// import "vue-layer/lib/vue-layer.css"
// Vue.use(layer)

Vue.config.productionTip = false

// let app = Vue.extend(app)
// let router = new VueRouter;
// // router.map({
// //   '/about':{
// //     components:about
// //   }
// // })
// const about = { template: '<div>foo</div>' } 
// const Bar = { template: '<div>bar</div>' }

// const routes = [
//   { path: '/about', component: about }
// ]
// const app = new Vue({
//   router
// }).$mount('#app')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js